export default "__VITE_ASSET__a561ef09__"